import PageTitle from '@frontend/features/pages/components/PageTitle'
import StoreLocatorMap from '@frontend/features/store-locators/StoreLocatorMap'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import { BreadcrumbItem, Breadcrumbs, cn } from '@nextui-org/react'
import BlogListLoader from '@scripts/frontend/features/blog/list/BlogListLoader'
import ErrorBoundary from '@shared/ErrorBoundary'
import NotFound from '@shared/screens/NotFound'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'
import { Link } from 'react-router-dom'

import PageTitleLoader from '../features/pages/components/PageTitleLoader'

const Loader = () => {
  return (
    <div className="my-10 space-y-10">
      <PageTitleLoader />
      <div className="grid gap-4 md:grid-cols-2">
        <BlogListLoader />
      </div>
    </div>
  )
}

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error, isLoading } = usePostBySlug('stores')

  if (isLoading) return <>Loading...</>

  if (error) {
    if ((error as { code?: string })?.code === 'not_found') {
      return <NotFound />
    }
    toast.error('Failed to fetch post')
    showBoundary(error)
  }

  if (!post) {
    showBoundary('No response data')
    return <></>
  }

  document.title = post.meta.title

  const { showTitle } = post.options

  const breadcrumbs = post.meta.breadcrumbs

  return (
    <div
      className={cn({
        'mb-12': !showTitle,
        'my-12': showTitle,
      })}
    >
      {showTitle && <PageTitle title={post.title} />}
      <Breadcrumbs
        className="mb-4 mt-12"
        itemClasses={{
          item: 'uppercase',
        }}
        separator="/"
      >
        {breadcrumbs.map((item) => (
          <BreadcrumbItem key={item.id}>
            <Link to={item.url}>{item.text}</Link>
          </BreadcrumbItem>
        ))}
      </Breadcrumbs>
      <StoreLocatorMap />
    </div>
  )
}

export function StoreLocator() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default StoreLocator
